import { render, staticRenderFns } from "./HospitalContactDetail.vue?vue&type=template&id=09f6dd92&scoped=true&"
import script from "./HospitalContactDetail.vue?vue&type=script&lang=js&"
export * from "./HospitalContactDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f6dd92",
  null
  
)

export default component.exports